import script from "./PlatformPoliciesDoctorView.vue?vue&type=script&lang=ts&setup=true"
export * from "./PlatformPoliciesDoctorView.vue?vue&type=script&lang=ts&setup=true"

import "./PlatformPoliciesDoctorView.vue?vue&type=style&index=0&id=1ea855c5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ea855c5"]])

export default __exports__